import React from "react";
import { Button, Modal } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { setIsConfirmation } from "../../redux/slices/globalSlice";
import "./dialog.scss";

const Confirmation = ({
  isRemove = false,
  onSubmit = () => {},
  onClose,
  onRemove = () => {},
  onRemoveMultiple = () => {},
  onCancel,
}) => {
  const dispatch = useDispatch();
  const {
    isConfirm,
    confirmationTitle,
    confirmationContent,
    confirmationData,
    isMultipleRecordsSelected,
  } = useSelector((state) => state.globalReducer);

  const handleOk = () => {
    dispatch(setIsConfirmation(false));
  };

  const handleCancel = () => {
    dispatch(setIsConfirmation(false));
    if (onCancel) {
      onCancel();
    }
  };

  // Function to capitalize the first letter of a string
  const capitalizeFirstLetter = (text) => {
    return text ? text.charAt(0).toUpperCase() + text.slice(1) : "";
  };

  return (
    <Modal
      title={confirmationTitle}
      open={isConfirm}
      onClose={onClose}
      onOk={handleOk}
      onCancel={handleCancel}
      centered
      footer={
        isRemove ? (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Button onClick={handleCancel}>Cancel</Button>
            <Button
              onClick={isMultipleRecordsSelected ? onRemoveMultiple : onRemove}
              type="primary"
              danger
            >
              Delete
            </Button>
          </div>
        ) : (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Button className="confirmation-cancel-btn" onClick={handleCancel}>
              No
            </Button>
            <Button
              type="primary"
              onClick={() => {
                onSubmit();
              }}
              className="confirmation-submit-btn"
            >
              Yes
            </Button>
          </div>
        )
      }
    >
      <p className="box-center">
        {confirmationContent}
        {!isMultipleRecordsSelected && (
          <span className="text-primary confirmation-text">
            {capitalizeFirstLetter(confirmationData)}
          </span>
        )}
        {!isMultipleRecordsSelected && "?"}
      </p>
    </Modal>
  );
};

export default Confirmation;
